import { DynamicDateRangePicker } from '../dynamic-date-range-picker';
import { withSingleDynamicDate } from '../dynamic-date-panel/withSingleDynamicDate';
export var DynamicDatePicker = withSingleDynamicDate(DynamicDateRangePicker);